(function(window, mediaInterfaceFactory) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.mediaInterface = mediaInterfaceFactory(window,
      window.$,
      namespace.log,
      namespace.deviceInfo,
      namespace.quizService,
      namespace.fathomService,
      namespace.mediaPlayer,
      namespace.playerView,
      namespace.playerConfiguration,
      namespace.events,
      namespace.themeController,
      namespace.PluginController);
})(this, function(window, $, log, deviceInfo, quizService, fathomService, mediaPlayer, playerView, playerConfiguration, events, themeController, PluginController) {
   'use strict';

   // all of these events may be valid, it is not guaranteed that all of these events will fire for every sp media type
   var _validEvents = [
      // events that we may not want to connect to media element directly
      // 'suspend', 'abort', 'emptied', 'stalled'
      'loadstart', // TODO: it'd be neat if we could fire 'loadstart' event before the actual mediaElement is initialized, but problematic atm so just let the element fire it
      'loadedmetadata', 'loadeddata', 'canplay', 'canplaythrough',
      'playing', 'waiting', 'seeking',
      'seeked', 'ended', 'play', 'pause', 'resize', 'error',
      'volumechange', 'durationchange', 'ratechange', 'timeupdate', 'progress'
   ];
   var _started = false;
   var _environment = 'live';
   var _controls = 'autohide';
   var _authInfo = {};
   var _lastError = null;
   var _pluginController = null;

   var addEventListener = function(type, callback) {
      if (_validEvents.indexOf(type) !== -1) {
         playerView.addMediaEventListener(type, callback);
      } else {
         playerView.addEventListener(type, callback);
      }
   };

   var removeEventListener = function(type, callback) {
      if (_validEvents.indexOf(type) !== -1) {
         playerView.removeMediaEventListener(type, callback);
      } else {
         playerView.removeEventListener(type, callback);
      }
   };

   var getAutoPlay = function(value) {
      playerConfiguration.setAutoPlayMedia(String(value).toLowerCase() === 'true');
   };

   var getCurrentTime = function() {
      return playerView.getCurrentTime();
   };

   var getControls = function() {
      return _controls;
   };

   var setControls = function(value) {
      if (String(value).toLowerCase() === 'false') {
         _controls = value;
         playerConfiguration.setDisableControls(true);
         playerConfiguration.setAutoHideControls(false);
      } else if (String(value).toLowerCase() === 'true') {
         _controls = value;
         playerConfiguration.setDisableControls(false);
         playerConfiguration.setAutoHideControls(false);
      } else { // default 'autohide'
         _controls = 'autohide';
         playerConfiguration.setDisableControls(false);
         playerConfiguration.setAutoHideControls(true);
      }

      mediaPlayer.triggerEvent(events.Controls.Updated, {newValue: value});
   };

   var setDisableInteractions = function(disableInteractions) {
      playerConfiguration.setDisableInteractions(disableInteractions);
      mediaPlayer.triggerEvent(events.Controls.Updated);
   };

   var getLoop = function() {
      var endActionParam = playerConfiguration.getEndActionParam();
      return playerConfiguration.getEndActionType().toLowerCase() === 'loop' && (endActionParam === 'true' || endActionParam === '1');
   };

   var setLoop = function(value) {
      if (String(value).toLowerCase() === 'true') {
         playerConfiguration.setEndActionType('loop');
         playerConfiguration.setEndActionParam('true');
      } else {
         playerConfiguration.setEndActionType('stop');
         playerConfiguration.setEndActionParam('true');
      }
   };

   var getError = function() {
      return _lastError;
   };

   var setMuted = function(value) {
      playerView.setMuted(String(value).toLowerCase() === 'true');
   };

   var getEnvironment = function() {
      return _environment;
   };

   var setEnvironment = function(value) {
      switch (String(value).toLowerCase()) {
         case '0':
         case 'local':
            {
               _environment = 0;
               break;
            }
         case '1':
         case 'dev':
            {
               _environment = 1;
               break;
            }
         case '2':
         case 'stage':
            {
               _environment = 2;
               break;
            }
         case '3':
         case 'live':
         default:
            {
               _environment = 3;
               break;
            }
         case '4':
         case 'te':
         case 'test':
            {
               _environment = 4;
               break;
            }
      }

      // these are the only uses of fathomService and quizService in this file, just to set this config =\
      fathomService.setEnvironment(_environment);
      quizService.setEnvironment(_environment);
   };

   var getAuthInfo = function() {
      return _authInfo;
   };
   var setAuthInfo = function(value) {
      if (typeof value === 'object') {
         _authInfo = $.extend(_authInfo, value);
      }
   };

   var addMediaSrc = function(src) {
      playerConfiguration.addMediaSrc(src);
   };

   var generalErrorHandler = function(event) {
      _lastError = event.data;
   };

   var run = function(containerId) {
      if (_started) {
         return;
      }

      deviceInfo.lookAtDevice();
      if (deviceInfo.isIOS() && !deviceInfo.getIOSSupportsInlineVideo()) {
         if (_authInfo.signInToken && _authInfo.returnUrl) {
            playerConfiguration.setAdditionalAppQueryParamsFromJson({sourceurl: encodeURIComponent(playerConfiguration.getMediaSrc()), signintoken: _authInfo.signInToken, returnUrl: encodeURIComponent(_authInfo.returnUrl)});
         } else {
            playerConfiguration.setAdditionalAppQueryParamsFromJson({sourceurl: encodeURIComponent(playerConfiguration.getMediaSrc())});
         }
      }
      if (_authInfo.accessTokenEndpoint) {
         playerConfiguration.setTechSmithAccessTokenEndpoint(_authInfo.accessTokenEndpoint);
      }

      playerConfiguration.setDisableFullframeMode(true);
      playerConfiguration.setFullViewPort(false);

      mediaPlayer.init('#' + containerId);

      addEventListener('error', generalErrorHandler);

      _started = true;
   };

   var destroy = function() {
      if (!_started) {
         return;
      }
      var $spElement = mediaPlayer.getSmartPlayerRootElement();
      removeEventListener('error', generalErrorHandler);
      mediaPlayer.destroy();

      if ($spElement) {
         $spElement.remove();
      }

      playerConfiguration.clearConfiguration();

      _started = false;
      _environment = 'live';
      _controls = 'autohide';
      _authInfo = {};
      _lastError = null;
      _pluginController = null;
   };

   var setTheme = function(themeName) {
      themeController.setTheme(themeName);
   };

   var setupPluginController = function() {
      _pluginController = PluginController.create();
      playerConfiguration.setPluginController(_pluginController);
   };

   var registerPlugin = function(pluginName, viewElementType) {
      if (!_pluginController) {
         setupPluginController();
      }
      var pluginInitPromise = _pluginController.registerPlugin(pluginName, viewElementType);
      mediaPlayer.triggerEvent(events.Plugin.Added);
      return pluginInitPromise;
   };

   return Object.defineProperties({
      play: playerView.play,
      pause: playerView.pause,
      addEventListener: addEventListener,
      removeEventListener: removeEventListener,
      addSrc: addMediaSrc,
      run: run,
      destroy: destroy,
      setTheme: setTheme,
      registerPlugin: registerPlugin
   }, {
      autoplay: {
         get: playerConfiguration.getAutoPlayMedia,
         set: getAutoPlay
      },
      buffered: {
         get: playerView.getBuffered
      },
      controls: {
         get: getControls,
         set: setControls
      },
      disableInteractions: {
         get: playerConfiguration.getDisableInteractions,
         set: setDisableInteractions
      },
      currentSrc: {
         get: playerView.getCurrentSrc
      },
      currentTime: {
         get: getCurrentTime,
         set: playerView.setCurrentTime
      },
      duration: {
         get: playerView.getDuration
      },
      error: {
         get: getError
      },
      ended: {
         get: playerView.getEnded
      },
      loop: {
         get: getLoop,
         set: setLoop
      },
      muted: {
         get: playerView.getMuted,
         set: setMuted
      },
      paused: {
         get: playerView.getPaused
      },
      playbackRate: {
         get: playerView.getPlaybackRate,
         set: playerView.setPlaybackRate
      },
      played: {
         get: playerView.getPlayed
      },
      preload: {
         get: playerConfiguration.getPreload,
         set: playerConfiguration.setPreload
      },
      seekable: {
         get: playerView.getSeekable
      },
      seeking: {
         get: playerView.getSeeking
      },
      volume: {
         get: playerView.getVolume,
         set: playerView.setVolume
      },
      src: {
         get: playerConfiguration.getMediaSrc,
         set: playerConfiguration.setMediaSrc
      },
      // these are the SP extended interface options
      posterSrc: {
         get: playerConfiguration.getPosterImageSrc,
         set: playerConfiguration.setPosterImageSrc
      },
      xmpSrc: {
         get: playerConfiguration.getXMPSrc,
         set: playerConfiguration.setXMPSrc
      },
      tocSrc: {
         get: playerConfiguration.getTOCSpriteSrc,
         set: playerConfiguration.setTOCSpriteSrc
      },
      prerollSrc: {
         get: playerConfiguration.getPreRollSrc,
         set: playerConfiguration.setPreRollSrc
      },
      quizId: {
         get: playerConfiguration.getFathomId,
         set: playerConfiguration.setFathomId
      },
      background: {
         get: playerConfiguration.getBackgroundColor,
         set: playerConfiguration.setBackgroundColor
      },
      captions: {
         get: playerView.getCaptionCollection
      },
      captionTrack: {
         get: playerView.getCaptionTrack,
         set: playerView.setCaptionTrack
      },
      captionsVisible: {
         get: playerView.getCaptionsVisible,
         set: playerView.setCaptionsVisible
      },
      ignoreStoredCaptionVisible: {
         get: playerConfiguration.getIgnoreStoredCaptionVisibleSetting,
         set: playerConfiguration.setIgnoreStoredCaptionVisibleSetting
      },
      rotation: {
         get: playerConfiguration.getMediaRotation,
         set: playerConfiguration.setMediaRotation
      },
      scrubbing: {
         get: playerView.getScrubbing,
         set: playerView.setScrubbing
      },
      isYouTube: {
         get: playerView.getIsYouTube
      },
      isInFullScreenMode: {
         get: playerView.isInFullScreenMode
      },
      authInfo: {
         get: getAuthInfo,
         set: setAuthInfo
      },
      // debug layer flags
      environment: {
         get: getEnvironment,
         set: setEnvironment
      },
      endActionType: {
         get: playerConfiguration.getEndActionType,
         set: playerConfiguration.setEndActionType
      },
      endActionParam: {
         get: playerConfiguration.getEndActionParam,
         set: playerConfiguration.setEndActionParam
      },
      ignoreXmpControllerParameters: {
         get: playerConfiguration.getIgnoreXmpControllerParameters,
         set: playerConfiguration.setIgnoreXmpControllerParameters
      },
      ignoreQuizQuestions: {
         get: playerConfiguration.getIgnoreQuizQuestions,
         set: playerConfiguration.setIgnoreQuizQuestions
      },
      singleClickControlEnabled: {
         get: playerConfiguration.getEnableSingleClickControl,
         set: playerConfiguration.setEnableSingleClickControl
      },
      doubleClickControlEnabled: {
         get: playerConfiguration.getEnableDoubleClickControl,
         set: playerConfiguration.setEnableDoubleClickControl
      },
      useLargerProgressBar: {
         get: playerConfiguration.getUseLargerProgressBar,
         set: playerConfiguration.setUseLargerProgressBar
      },
      displayHotspotsShape: {
         get: playerConfiguration.getDisplayHotspotsShape,
         set: playerConfiguration.setDisplayHotspotsShape
      },
      disablePictureInPicture: {
         get: playerConfiguration.getDisablePictureInPicture,
         set: playerConfiguration.setDisablePictureInPicture
      },
      audioDescriptionMediaSrc: {
         get: playerConfiguration.getAudioDescriptionMediaSrc,
         set: playerConfiguration.setAudioDescriptionMediaSrc
      }
   });
});
